import styled from "styled-components";
import { styled as muiStyled } from "@mui/system";

//Internal
import { px2vw, device } from "../../utils/device";
import { Avatar } from "@mui/material";

const LoginImg = styled.img`
  @media ${device.mobileS} {
    height: 10vh;
    width: ${px2vw(150, 400)};
  }

  @media ${device.mobileL} {
    height: 10vh;
    width: ${px2vw(200, 400)};
  }

  @media ${device.tablet} {
    height: 10vh;
    width: ${px2vw(200, 801)};
  }

  @media ${device.laptopL} {
    height: 10vh;
    width: ${px2vw(200)};
  }
`;

const LoginDivContainer = styled.div`
  min-height: ${(props) => props.divStyle.divMinHeight || "100vh"};
  display: flex;
  background-color: #282c34;
  color: #fff;
  font-weight: 600;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${device.mobileS} {
    font-size: ${(props) => {
      let _fSize = props.divStyle.divFontSize.mobileS || "30";
      return px2vw(_fSize, 400);
    }};
  }

  @media ${device.mobileL} {
    font-size: ${(props) => {
      let _fSize = props.divStyle.divFontSize.mobileL || "25";
      return px2vw(_fSize, 400);
    }};
  }

  @media ${device.tablet} {
    font-size: ${(props) => {
      let _fSize = props.divStyle.divFontSize.tablet || "40";
      return px2vw(_fSize, 801);
    }};
  }

  @media ${device.laptopL} {
    font-size: ${(props) => {
      let _fSize = props.divStyle.divFontSize.laptopL || "20";
      return px2vw(_fSize, 1025);
    }};
  }
`;

const LoginAvatar = muiStyled(
  Avatar,
  {}
)(({ theme }) => ({
  [theme.breakpoints.up("tablet")]: {
    height: "50px",
    width: "50px",
    marginTop: "30px",
  },
  [theme.breakpoints.up("laptop")]: {
    height: "100px",
    width: "100px",
    marginTop: "30px",
  },
}));

export { LoginDivContainer, LoginImg, LoginAvatar };
